module.exports = __webpack_public_path__ + "static/the-office-of-the-future-a3522ac5cdf313326994b3afa1a88d1a.png";